export const COMPANY_ACTIONS = {
    COMPANY_SEARCH: 'COMPANY_SEARCH',
    COMPANY_SEARCH_SUCCESS: 'COMPANY_SEARCH_SUCCESS',
    COMPANY_SEARCH_ERROR: 'COMPANY_SEARCH_ERROR',

    COMPANY_UPSERT: 'COMPANY_UPSERT',
    COMPANY_UPSERT_SUCCESS: 'COMPANY_UPSERT_SUCCESS',
    COMPANY_UPSERT_ERROR: 'COMPANY_UPSERT_ERROR',

    COMPANY_EDIT: 'COMPANY_EDIT',

    COMPANY_RESET: 'COMPANY_RESET',
};

export const companyResetAction = () => ({
    type: COMPANY_ACTIONS.COMPANY_RESET,
});

export const companySearchAction = (payload) => ({
    type: COMPANY_ACTIONS.COMPANY_SEARCH,
    ...payload,
});

export const companyEditAction = (payload) => ({
    type: COMPANY_ACTIONS.COMPANY_EDIT,
    ...payload,
});

export const companyUpsertAction = (payload) => ({
    type: COMPANY_ACTIONS.COMPANY_UPSERT,
    ...payload,
});

export default {
    COMPANY_ACTIONS,
    companySearchAction,
    companyUpsertAction,
    companyEditAction,
};
